import { toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";

// @General
export const somethingWentWrongToast = () =>
  toast.warning("Something Went Wrong", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const qtyToast = () =>
  toast.warning("You can't input value greater than the available quantity", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  export const hospitalToast = () =>
  toast.warning("Please select a hospital", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const customerToast = () =>
  toast.warning("Customer did not initiate this order", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  export const genotypeToast = () =>
  toast.success("Price has been updated", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const adminToast = () =>
  toast.success("Admin will be notify", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @Authentication
export const loginSuccessToast = () =>
  toast.success("Login Successful", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const logoutSuccessToast = () =>
  toast.success("", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const invalidCredentialToast = () =>
  toast.warning("Invalid Credentials", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const passwordChangedSuccessToast = () =>
  toast.success(
    `Password Updated Successfully.
    Sign in with your new password`,
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
export const passwordChangedWarningToast = () =>
  toast.warn(`Invalid old password`, {
    position: "top-right",
    autoClose: 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

//finance
export const contactFinance = () => {
  toast.warn(
    "Pricing is not available for this product. Contact Finance Team.",
    {
      position: "top-right",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
};

// @Order
export const orderCreateSuccessToast = () =>
  toast.success("Order Created Successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const bidCreateSuccessToast = () =>
  toast.success("Bid Accepted", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const financeNotApproved = () =>
  toast.warning(
    "Quotations cannot be send at the moment. Please finance need to approve your request.",
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );

// @faild order
export const failedOrder = () =>
  toast.warning("Order not successfully placed. Try again", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const failedBid = () =>
  toast.warning("Bid Failed. Try again", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const uploadInventoryToast = () =>
  toast.warning("Inventory List Is Empty", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const addInventoryToast = () =>
  toast.warning("Please select an item and input price and quantity", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const financeFailed = () =>
  toast.warning("Failed to send to finance", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const sendFinance = () =>
  toast.success("Finance  will be notified shortly.", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const complainToast = () =>
  toast.success("Complain Sent.", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const closeToast = () =>
  toast.success("Order Closed Successfully.", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const reasonToast = () =>
  toast.success("Feedback Sent.", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const returnToast = () =>
  toast.success("Order has been returned successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const successAlert = () => {
  Swal.fire({
    // position: "top-end",
    icon: "success",
    title: "product added successfully",
    showConfirmButton: false,
    timer: 7000,
  });
};

export const hospitalAlert = () => {
  Swal.fire({
    // position: "top-end",
    icon: "warning",
    title: "Pease use the Nerve App",
    showConfirmButton: false,
    timer: 7000,
  });
};

export const returnAlert = () => {
  Swal.fire({
    // position: "top-end",
    icon: "success",
    title: "Order has been returned successfully",
    showConfirmButton: false,
    timer: 7000,
  });
};
